import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import swal from 'sweetalert2';

import { Product, Products } from '../product/models/product';
import { ServicesService } from '../services/services.service';

// import { forEach } from '@angular/router/src/utils/collection';
@Component({
  selector: 'app-create-orders',
  templateUrl: './create-orders.component.html',
  styleUrls: ['./create-orders.component.css']
})
export class CreateOrdersComponent implements OnInit {

  cid: any;
  clientName: any;
  currentPage: number = 1;
  // loader: boolean = false;
  paginate = {
    'last_page': 1
  };
  searchFields = [];
  pages: any;
  editData: Object = {};
  routePath: any;
  listData: any;
  descrition = []
  fields: any;
  showloader = false;
  submitted = false;
  cname: any;
  information = false;
  selectedProduct = '';
  inputValidate = []

  orderAmt: number = 0;
  totalAmt: number = 0;
  taxAmt: number = 0;
  tempProductId: any;

  routeData;
  orderProjectList: any;

  component: Object = {};
  orderDetails: any = {
    'client_id': '',
    'order_no_unique': '',
    'order_no': '',
    'order_date': '',
    'product': [],
    'productData': [],
    'component': [],
    'componentData': [],
    'project_order_id': '',
  };

  selectedProducts = [];
  dropdownList = [];
  selectedItems = [];
  dropdownSettings: IDropdownSettings = {};

  constructor(private route: ActivatedRoute, private _services: ServicesService, private router: Router) {
    this.route.queryParams.subscribe(params => {
      this.cid = params['cid'];
      this.cname = params['cname'];
      this.orderDetails['client_id'] = this.cid;
    })
  }

  ngOnInit() {
    this.clientName = this.cname;
    this._services.checkToken('status');
    this.getProductsComponents();
    this.getOrderProjectList();

    $('#productSel').change(function () {
      // //console.log('#' + $(this).val());
      $('#' + $(this).val()).show();
    });

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'product_id',
      textField: 'product_name',
      selectAllText: 'Select Product',
      unSelectAllText: 'Remove product',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    let now = new Date();
    let currentMont = now.getMonth() + 1;
    let randomNumPart = Math.floor((Math.random() * 99)).toString().padStart(2, '0');
    this.orderDetails['order_no'] = now.getDate() + '' + currentMont + '' + now.getFullYear() + '' + randomNumPart;

    this.fields = [
      {
        'field': 'component_name',
        'title': 'Component Name',
        'width': '30%',
        'code': true,
        'sort': false,
      },
      {
        'field': 'quantity',
        'title': 'Quantity',
        'width': '25%',
        'code': false,
        'sort': false,
      }
    ]
  }


  createOrder() {
    // //console.log(this.orderDetails['project_order_id']);
    console.log(this.orderDetails['product']);

    this.orderDetails['product'] = Array.from(new Set(this.orderDetails['product']));
    this.orderDetails['componentData'] = Array.from(new Set(this.orderDetails['componentData']));

    this.fillProductDataWithUnneccesaryNullValues(this.orderDetails['product']);

    this.orderDetails['total_amt'] = this.totalAmt;
    this.orderDetails['order_amt'] = this.orderAmt;
    var main_counter = 0;
    var counter = 0;
    var flag1 = 0;
    var flag2 = 0;
    var flag3 = 0;
    var flag4 = 0;
    let i = 0;
    if (this.orderDetails['product'] && this.orderDetails['componentData'] && this.orderDetails['total_amt'] && this.orderDetails['order_amt'] && this.orderDetails['productData']) {
      this.orderDetails['productData'].filter(p => p != null).forEach(obj => {
        // //console.log('obj length: ',obj);
        // //console.log('components_list ',obj.components_list.length);
        let null_counter = 0;
        // if(flag4==0) {
        obj.components_list.forEach(childObj => {
          if (!childObj.qty) {
            ++null_counter;
          }
          if (obj.components_list.length == null_counter) {
            flag4 = 1;
            this.inputValidate[main_counter] = 1;
          }
          // alert(childObj.qty);
          /* if(childObj.qty) {
           if(obj.product_id == this.orderDetails['product'][main_counter-1]) {
           counter = counter +1;
           }
           }*/
        })
        // }
        if (flag4 == 0) {
          this.inputValidate[main_counter] = 0;
        }
        if (flag4 == 1) {
          this.inputValidate[main_counter] = 1;
          /*swal({
            type: 'warning',
            title: 'Oops...',
            text: 'Please fill atleast one category'
          })
          return;*/
        }
        if (obj.quantity) {
          flag1 = 1;
        } else {
          flag1 = 1;
        }
        if (obj.description) {
          flag2 = 1;
        } else {
          flag2 = 0;
        }
        if (obj.amount) {
          flag3 = 1;
        } else {
          flag3 = 0;
        }
        main_counter++;
      });

      if (flag1 == 1 && flag2 == 1 && flag3 == 1 && flag4 == 0) {
        //console.log("formdata", this.orderDetails);
        this.showloader = true;
        this._services.requestCreator(this.orderDetails, 'create-client-order', this._services.getToken()).subscribe((data: any) => {
          if (this._services.checkToken(data.status)) {
            if (data.status == '200') {
              //console.log("formdata", data);
              // this.isFormSubmitted=false;
              this.showloader = true;
              swal({
                title: 'Order Added Successfully',
                text: 'You Successfully Added Order',
                type: 'success',
                showCancelButton: false,
                confirmButtonColor: 'rgb(17, 205, 239)',
                cancelButtonColor: 'rgb(245, 54, 92)',
                confirmButtonText: 'Yes'
              }).then(() => {
                this.orderDetails = {};
                this.showloader = true;
                this.router.navigateByUrl('/orders-list', { queryParams: { 'cid': this.cid } });
              })
            } else {
              this.showloader = false;
              // this.isFormSubmitted=false;
            }
          }
        });
      } else {
        /*swal({
          type: 'warning',
          title: 'Oops...',
          text: 'Please fill all the fields!'
        })*/
      }
    } else {
      /* swal({
         type: 'warning',
         title: 'Oops...',
         text: 'Please fill all the fields!'
       })*/
    }
  }

  private fillProductDataWithUnneccesaryNullValues(productIds: number[]): void {
    const result: Products = [];
    const numericIds = productIds.map(val => +val)
    const max = Math.max(...numericIds);

    for (let i = 0; i <= max; i++) {
      if (!productIds.includes(i)) {
        result.push(null);
      } else {
        result.push(this.selectedProducts.find(product => product.product_id == i));
      }
    }

    this.orderDetails['productData'] = result;
    // return result;
  }

  getProductsComponents() {
    this.routePath = 'get-products-components-list';
    let data = {
      'client_id': this.cid,
    }
    const token = localStorage.getItem('userToken');
    this._services.requestCreator(data, this.routePath, token).subscribe((result: any) => {
      if (this._services.checkToken(result.status)) {
        this.listData = result.result;
        console.log(result.result);

      }
    });
    return true;
  }

  onItemSelect(item: any) {

    this.orderDetails['product'].push(item.product_id);
    this.listData.forEach((value) => {
      if (value.product_id === item.product_id) {
        this.selectedProducts.push(value);
      }
    });

  }

  onItemDeSelect(event) {
    this.orderDetails['product'] = this.orderDetails['product'].filter((value) => {
      return value !== event.product_id;
    });
    this.selectedProducts = this.selectedProducts.filter((value) => {
      return value.product_id !== event.product_id;
    });

    this.updateTotalAmount(this.selectedProducts);
  }

  private updateTotalAmount(selectedProducts: Products): void {
    this.orderAmt = 0;

    if (selectedProducts && selectedProducts.length > 0) {
      selectedProducts.forEach(product => {
        this.orderAmt += (product.amount * product.quantity);
      });
    }

    this.taxAmt = this.orderAmt * 0.15;
    this.totalAmt = this.orderAmt + this.taxAmt;
  }

  onTotalAmountChanged(amount: number): void {
    this.updateTotalAmount(this.selectedProducts);
  }

  getOrderProjectList() {
    let data;
    this.routeData = 'get-project-order-list';

    switch (this.routeData) {

      case 'get-project-order-list': {
        data = {
          page: this.currentPage,
          search: {
            'project_name': this.searchFields['project_name'],
          }
        };
        break;
      }
    }
    const token = localStorage.getItem('userToken');
    this._services.requestCreator(data, this.routeData, token).subscribe((result: any) => {
      if (this._services.checkToken(result.status)) {
        // //console.log(result.result);
        this.orderProjectList = result.result;
        // //console.log(this.orderProjectList);
      }
    });

    return true;
  }

  removeProduct(product: Product): void {
    this.selectedProducts.splice(this.selectedProducts.indexOf(product), 1);
  }

}